import {encode} from "../helpers/column_names";
import {pasteCondition} from "./conditional_formats";
import group from "./undo_group";

export function init(view){
	var table = view._table;

	table.attachEvent("onSelectChange", () => {
		if(view.$$("navigation")){
			let ranges = [];

			const areas = table.getAllSelectAreas();
			for(let name in areas){
				const sel = areas[name];
				const areaRange = view.posToRef(sel.start.row, sel.start.column, sel.end.row, sel.end.column);
				ranges.push(areaRange);
			}

			view.$$("navigation").setValue(ranges.join(";"));
		}
	});

	table.attachEvent("onBeforeAreaRemove", function(){
		const editor = view.$$("liveEditor");
		if(view._forceSelect || (editor && editor._activeMath && editor._activeMath != view.getActiveSheet())) return;
		if(view.$handleSelection || (editor && editor.handleSelect())) return false;
	});

	table.attachEvent("onBeforeAreaAdd", (area) => {
		//[FIXME] 
		//block selection of row-id column
		//temporary fix, we need to fire onBeforeBlockSelect when selection moves
		//so the common onBeforeBlockSelect handler will block rowId selection
		if (area.start.column == "rowId") return false;

		//if we have an active editor, we need to close it on block selection
		//ignore, when selecting the editor's cell
		const editor = table.getEditor();

		if (editor && (editor.row != area.start.row || editor.column != area.start.column))
			table.editStop();

		let res = true;

		const blockStart = encode[area.start.column] + area.start.row;
		const blockEnd = encode[area.end.column] + area.end.row;

		if(!view._forceSelect){
			if (view.$handleSelection){
				view.$handleSelection(area.start, area.end, blockStart, blockEnd);
				res = false;
			}
			else{
				const editor = view.$$("liveEditor");
				if(editor){
					if(editor.handleSelect()){
						editor.pasteRange(area.start, area.end, blockStart, blockEnd);
						res = false;
					}
					else if(editor.isEnabled()){
						const cell = editor.config.activeCell;
						if(editor._activeMath && editor._activeMath != view.getActiveSheet())
							res = false;
						editor.showActiveSheet();
						editor.updateCellValue(cell);
					}
				}
			}
		}

		if(view.$$("navigation")){
			let ranges = [];

			const currentRange = blockStart != blockEnd ? blockStart+":"+blockEnd : blockStart;

			const areas = table.getAllSelectAreas();
			for(let name in areas){
				const sel = areas[name];
				const areaRange = view.posToRef(sel.start.row, sel.start.column, sel.end.row, sel.end.column);
				ranges.push(areaRange);
			}

			if(!area.isMarkedForRemoval && res !== false)
				ranges.push(currentRange);

			view.$$("navigation").setValue(ranges.join(";"));
		}

		return res;
	});

	table.attachEvent("onBeforeBlockSelect", (start, end, finalStep, ev) => {
		if(view.$handleSelection && (table.$handleStart || !ev)) return false;
		if(!view.config.readonly && table.$handleStart){
			if(Object.keys(table.getAllSelectAreas()).length > 1){
				// onBeforeBlockSelect appears twice, so we use flag _denyAutofill to avoid of an extra alert message
				if(!view._denyAutofill){
					view.alert({text:webix.i18n.spreadsheet.labels["error-autofill-multiselect"], type: "alert-error"}).then(()=>{
						delete view._denyAutofill;
					});
					view._denyAutofill = true;
				}
				return false;
			}
			if(!finalStep) return;
			const oldSel = table.getSelectArea();
			const oldStart = oldSel.start;
			const oldEnd = oldSel.end;

			const sr = start.row;
			const er = end.row;
			const sc = start.column;
			const ec = end.column;

			if(oldStart.row == sr && oldEnd.row > er)
				view.clearRange({start:{row:er+1,column:sc}, end:{row:oldEnd.row,column:ec}}, {values:true});
			else if(oldStart.column == sc && oldEnd.column > ec){
				view.clearRange({start:{row:sr,column:ec+1}, end:{row:er,column:oldEnd.column}}, {values:true});
			}
			else{
				let type;
				if(sr != oldStart.row || er != oldEnd.row)
					type = "row";
				else if(sc != oldStart.column || ec != oldEnd.column)
					type = "column";

				if(type){
					group.start();
					const isRow = type == "row";

					const {dayShort, dayFull, monthShort, monthFull} = webix.i18n.calendar;

					const dayAndMonthNames = {
						dayShort: [dayShort, dayShort.map(v => v.toLowerCase())],
						dayFull: [dayFull, dayFull.map(v => v.toLowerCase())],
						monthShort: [monthShort, monthShort.map(v => v.toLowerCase())],
						monthFull: [monthFull, monthFull.map(v => v.toLowerCase())]
					};

					for (
						let i = (isRow ? sc : sr);
						i <= (isRow ? ec : er);
						i++
					){
						const nums = [];
						let border = [];

						for (let j = oldStart[type]; j <= oldEnd[type]; j++) {
							let dayOrMonthType;
							let dayOrMonthCase;

							const [row, col] = type == "row" ? [j, i] : [i, j];
							let value = view.getCellValue(row, col);

							if(typeof value == "string")
								for(let name in dayAndMonthNames){
									const lowerCaseNames = dayAndMonthNames[name][1];
									const index = lowerCaseNames.indexOf(value.toLowerCase());
									if(index != -1){
										const lowerCaseName = lowerCaseNames[index];

										if(value == lowerCaseName)
											dayOrMonthCase = "lower"; // sun, mon, tue, ...
										else if(value == lowerCaseName.toUpperCase())
											dayOrMonthCase = "upper"; // SUN, MON, TUE, ...
										//else like in locale: Sun, Mon, Tue, ...

										dayOrMonthType = name;
										value = index;
										break;
									}
								}

							if(webix.rules.isNumber(value)){
								if(border.type != dayOrMonthType)
									border = [];

								if(!border[0]){
									border.firstValue = value;
									border.type = dayOrMonthType;
									border.case = dayOrMonthCase;
									border[0] = border[1] = j;
								}
								else{
									border[1] = j;
									if(webix.isUndefined(border.inc))
										border.inc = value - border.firstValue;
								}

								nums[j] = {
									value,
									border
								};
							}
							else
								border = [];
						}

						const afterSel = oldStart[type] == (isRow ? sr : sc);
						const start = afterSel ? oldStart[type] : oldEnd[type];
						const dir = afterSel ? 1 : -1;

						for(
							let j = (afterSel ? oldEnd[type] + 1 : oldStart[type] - 1), index = 0, iteration = 1;
							afterSel ? j <= (isRow ? er : ec) : j >= (isRow ? sr : sc);
							afterSel ? j++ : j--, index++
						){
							if(index == oldEnd[type] - oldStart[type] + 1){
								iteration++;
								index = 0;
							}

							const linkPos = start+index*dir;
							const [linkRow, linkCol] = isRow ? [linkPos, i] : [i, linkPos];

							let value;

							let num = nums[linkPos];
							if(num){
								value = num.value;
								num = num.border;
								value += (num.inc === 0 ? 0 : (num.inc || 1)) * (num[1] - num[0] + 1) * iteration * dir;

								if(num.type){
									const names = dayAndMonthNames[num.type][0];
									const max = names.length;
									value = names[((value % max) + max) % max];
									if (num.case) value = num.case == "upper" ? value.toUpperCase() : value.toLowerCase();
								}
							}
							else{
								value = view.getCellValue(linkRow, linkCol);
								if(typeof value == "string" && value[0] == "=" && value.length > 0){
									if(isRow)
										value = view._mData.getStore().transposeMath(value, j - start - index * dir, 0);
									else
										value = view._mData.getStore().transposeMath(value, 0, j - start - index * dir);
								}
							}

							const [row, col] = isRow ? [j, i] : [i, j];
							view.setCellValue(row, col, value);
							view.setStyle(row, col, view.getStyle(linkRow, linkCol));

							const condition = view.conditions.get(linkRow, linkCol);
							if(condition)
								pasteCondition(view, {condition}, row, col);
							else
								view.conditions.clear(row, col);
						}
					}
					group.end();
				}
			}
		}
	});

	webix.event(table.$view, "mousedown", function(e){
		if (view.$handleSelection)
			return webix.html.preventEvent(e);
	});
}